// Vuex module for notifications
import useNotifications from '@/composables/useNotifications'

const { addNotification } = useNotifications()

export default {
  namespaced: true,
  actions: {
    showNotification ({ state }, { message, type = 'info', timeout = 3000 }) {
      addNotification({ message, type, timeout })
    },
    showError ({ state }, { message, timeout = 3000 }) {
      addNotification({ message, type: 'error', timeout })
    },
    showSuccess ({ state }, { message, timeout = 3000 }) {
      addNotification({ message, type: 'success', timeout })
    }
  }
}
